const state = () => ({
  isValid: false,
  firstName: ''
});

const getters = {
  isValid(state) {
    return state.isValid;
  },
  firstName(state) {
    return state.firstName;
  }
};

const mutations = {
  setIsValid(state, payload) {
    state.isValid = payload;
  },
  updateFirstName(state, payload) {
    state.firstName = payload;
  },
  resetStore(s) {
    Object.assign(s, state());
  }
};

const actions = {
  updateFirstName({ commit }, payload) {
    commit('updateFirstName', payload);
  }
};

export const firstName = {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
};
